import { Directive } from '@angular/core';
import { Widget } from '../core/dashboard.node';
import { DashboardNodeComponent } from './dashboard-node.component';

@Directive()
export abstract class WidgetComponent extends DashboardNodeComponent<Widget> {}
